import type { LandingLocale } from './landingContentTypes.js';

export interface ContactMapConsentCopy {
  title: string;
  text: string;
  loadLabel: string;
  unloadLabel: string;
  privacyLabel: string;
  loadingLabel: string;
  activeLabel: string;
}

const copy: Record<LandingLocale, ContactMapConsentCopy> = {
  de: {
    title: 'Unser Standort auf der Karte',
    text: 'Mit „Karte laden“ willigst du ein, dass eine Verbindung zur OpenStreetMap Foundation hergestellt wird. Dabei werden deine IP-Adresse und technische Verbindungsdaten übermittelt. Die Freigabe gilt nur für diese Ansicht. Über „Karte deaktivieren“ kannst du sie jederzeit widerrufen.',
    loadLabel: 'Karte laden',
    unloadLabel: 'Karte deaktivieren',
    privacyLabel: 'Datenschutz bei OpenStreetMap',
    loadingLabel: 'OpenStreetMap wird geladen …',
    activeLabel: 'OpenStreetMap ist für diese Ansicht freigegeben.',
  },
  en: {
    title: 'Find us on the map',
    text: 'By selecting “Load map”, you consent to a connection to the OpenStreetMap Foundation. Your IP address and technical connection data will be transmitted. Permission applies only to this view. You can withdraw it at any time by selecting “Disable map”.',
    loadLabel: 'Load map',
    unloadLabel: 'Disable map',
    privacyLabel: 'OpenStreetMap privacy policy',
    loadingLabel: 'Loading OpenStreetMap …',
    activeLabel: 'OpenStreetMap is enabled for this view.',
  },
  tr: {
    title: 'Haritada konumumuz',
    text: '“Haritayı yükle”yi seçerek OpenStreetMap Foundation ile bağlantı kurulmasına onay verirsin. IP adresin ve teknik bağlantı verilerin aktarılır. Onayın yalnızca bu görünüm için geçerlidir. “Haritayı devre dışı bırak”ı seçerek onayını istediğin zaman geri çekebilirsin.',
    loadLabel: 'Haritayı yükle',
    unloadLabel: 'Haritayı devre dışı bırak',
    privacyLabel: 'OpenStreetMap gizlilik politikası',
    loadingLabel: 'OpenStreetMap yükleniyor …',
    activeLabel: 'OpenStreetMap bu görünüm için etkinleştirildi.',
  },
};

export const contactMapConsentCopy = (
  locale: LandingLocale,
  overrides?: Partial<ContactMapConsentCopy>,
): ContactMapConsentCopy => ({
  ...copy[locale],
  ...overrides,
});

export const OPENSTREETMAP_PRIVACY_URL = 'https://osmfoundation.org/wiki/Privacy_Policy';
